import { Breakpoints } from '@angular/cdk/layout';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { useSelect } from '@bynary/composables/ngxs';
import { useBreakpoint } from '@bynary/composables/observer';
import { TranslateModule } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { SonaAuthUserMenuFacade, SonaUsageFacade } from '@sona/angular-auth-domain';
import { SonaLanguageMenuComponent } from '@sona/angular-feature-language-menu';
import { SonaOrganizationSwitcherComponent } from '@sona/angular-organization-feature-switcher';
import { SonaEndTrialMenuItemComponent } from '@sona/angular-payments/components';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { useI18n } from '@sona/angular-util-common';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { BrnMenuImports } from '@spartan-ng/ui-menu-brain';
import { HlmMenuComponent, HlmMenuItemImports, HlmMenuStructureImports } from '@spartan-ng/ui-menu-helm';
import { HlmTooltipTriggerDirective } from '@spartan-ng/ui-tooltip-helm';

@Component({
    selector: 'sona-auth-user-menu',
    imports: [
        RouterLink,
        TranslateModule,
        BrnMenuImports,
        HlmButtonDirective,
        SonaIconComponent,
        SonaLanguageMenuComponent,
        SonaOrganizationSwitcherComponent,
        HlmMenuComponent,
        HlmMenuItemImports,
        HlmMenuStructureImports,
        NgTemplateOutlet,
        SonaEndTrialMenuItemComponent,
        HlmTooltipTriggerDirective
    ],
    templateUrl: './user-menu.component.html',
    host: {
        class: 'tw-contents'
    }
})
export class SonaAuthUserMenuComponent {
    protected readonly _authFacade = inject(SonaAuthUserMenuFacade);
    protected readonly _usageFacade = inject(SonaUsageFacade);
    private readonly _i18n = useI18n();

    protected readonly isMobile = useBreakpoint(Breakpoints.Handset);
    protected readonly user = select(SonaAuthUserMenuFacade.user);
    private readonly _accessToken = select(SonaAuthUserMenuFacade.accessToken);
    protected readonly featurebaseUrl = computed(() => {
        const jwt = this._accessToken();

        if (!jwt) {
            return null;
        }

        const params = new URLSearchParams({
            jwt,
            return_to: `https://siteboard.featurebase.app/${this._i18n().language}`
        });
        return `https://siteboard.featurebase.app/api/v1/auth/access/jwt?${params}`;
    });

    updateUserLang(language: string) {
        if(!this.user()) {
            return;
        }

        void this._authFacade.updateUserLanguage(language);
    }

    async signOut() {
        await this._authFacade.signOut();
    }
}
